// eslint-disable-next-line no-unused-vars
import { getToken, removeUSERINFO, removeToken, removeSYSTEMINFO } from '@/store/cookies'
// eslint-disable-next-line no-unused-vars
import store from '@/store'
import route from '@/router'
// 路由白名单
// eslint-disable-next-line no-unused-vars
const whiteRouter = ['/login'] // indexOf方法，判断数组中是否存在指定的某个对象，如果不存在，则返回-1

/**
 * 1、直接进入index的时候，参数to被改变成了 "/index"，触发路由指向，就会跑beforeEach
 * 2、再一次 next 指向了login，再次发生路由指向，再跑beforeEach，参数的to被改变成了"/login"
 * 3、白名单判断存在，则直接执行next()，因为没有参数，所以不会再次beforeEach。
 */
route.beforeEach((to, from, next) => {
    if (window._hmt) {
        if (to.path) {
            window._hmt.push(['_trackPageview', '/#' + to.fullPath])
        }
    }
    if (to.path == '/home' && to.query && to.query.appkey) {
        //外链规则
        console.log("外部链接访问命中")
        store.dispatch('menu/thirdLoginStore', to.query).then(() => {
            console.log("跳转到", to)
            next(to.path)
        }).catch(err => {
            next('/login')
        })
    } else {
        const token = getToken()
        if (token) {
            if (to.path === '/login') {
                console.log("之前有token:" + token + "但是访问login路径,跳转登录页")
                removeUSERINFO()
                removeSYSTEMINFO()
                removeToken()
                store.commit('menu/removeSYSTEMINFO')
                store.commit('menu/removeToken')
                store.commit('menu/removeUSERINFO')
                store.commit('menu/removeASYNCROUTERS')
                store.commit('menu/removeALLROUTERS')
                store.commit('menu/removeArrJurisdiction')
                store.commit('menu/removeBUTTONS')
                // next('/home')
                next()
            } else if (to.path === null) {
                next('*')
            } else {
                if (store.getters['menu/getASYNCROUTERS'].length === 0) {
                    store.dispatch('menu/dynamicAddRouter', store.getters['menu/getArrJurisdiction']).then(res => {
                        route.addRoutes(store.getters['menu/getASYNCROUTERS'])
                        route.options.routes = store.getters['menu/getALLROUTERS']
                        next({ ...to, replace: true })
                    })
                } else {
                    next()
                }
            }
        } else {
            if (whiteRouter.indexOf(to.path) !== -1) { //包含
                next()
            } else {
                console.log("之前无token跳转登录页")
                next('/login') // 直接返回到登陆页面
            }
        }
    }
})